import axios from "axios";
import { API_URL } from "./index";
class FilmReleaseService {
    getAll = (params) => {
        const url = API_URL.filmRelease("find-by-criteria");
        return axios.get(url, { params }).then((response) => response);
    };
    getFilmRelease = (id) => {
        const url = API_URL.filmRelease(id);
        return axios.get(url).then((response) => response);
    };

    getUnreportedCount = (params) => {
        const url = API_URL.filmRelease("unreported-count");
        return axios.get(url, { params }).then((response) => response.data);
    };

    createFilmRelease = (body) => {
        const url = API_URL.filmRelease();
        return axios.post(url, body).then((response) => response);
    };

    editFilmRelease = (body) => {
        const url = API_URL.filmRelease();
        return axios.put(url, body).then((response) => response);
    };

    getNomenclator = (url) => axios.get(url);
    getFilmByTitle = ({ titlePattern, companyIds }) => {
        const url = API_URL.filmRelease("find-by-title");
        return axios.get(url, {
            params: {
                titlePattern,
                companyIds,
            },
        });
    };

    mergeFilmRelease = (releaseSourceId, releaseDestId) => {
        const url = API_URL.filmRelease("merge-films");
        return axios
            .put(url,null, {
                params: {
                    releaseSourceId,
                    releaseDestId,
                },
            })
            .then((response) => response.data);
    };

    associateFilmRelease = (releaseSourceId, releaseDestId) => {
        const url = API_URL.filmRelease("associate-films");
        return axios
            .put(url, null,{
                params: {
                    releaseSourceId,
                    releaseDestId,
                },
            })
            .then((response) => response.data);
    };

    deleteFilmRelease = (id, confirmationMessage) => {
        let url = API_URL.filmRelease(id);
        return axios
            .delete(url, {
                params: { confirmationMessage },
            })
            .then((response) => response);
    };

    cloneAdv = ({ prevFilmRelease, nextFilmRelease, contactId, advertisementsIds }) => {
        const url = API_URL.filmRelease();

        return axios.put(url + "/clone-adv", {
            filmCloneFromId: prevFilmRelease,
            filmCloneToId: nextFilmRelease,
            contactId,
            advIds: advertisementsIds,
        });
    };
    getFilmReleaseHistory = (id) => {
        const url = API_URL.filmRelease(`${id}/history`);
        return axios.get(url).then((response) => response.data);
    };
}

export default new FilmReleaseService();
